import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { ConfigService } from '../../../core/config/config.service';
import { ConfigDTO } from '../../../core/api/models/configDTO.model';
import { SESSION_STORAGE_KEYS } from 'app/core/session_storage/constants/session-storage-keys.constant';
import { DataService } from '@shared/services/data/data.service';
import { ShellComponent } from '../shell/shell.component';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  imports: [ShellComponent, ButtonModule],
})
export class ConfigurationComponent implements OnInit, OnDestroy {
  isConfigLoaded: boolean = false;
  private subscription?: Subscription;
  private readonly changeDetector = inject(ChangeDetectorRef);

  constructor(
    public readonly configService: ConfigService,
    public readonly dataService: DataService,
  ) {}

  ngOnInit(): void {
    // Check if the user is in the onboarding process => onboarding active is set in the session storage
    const isCurrentlyOnboarding: string = sessionStorage.getItem(SESSION_STORAGE_KEYS.ONBOARDING_ACTIVE);

    if (isCurrentlyOnboarding !== null) {
      // We are in the onboarding process, so there is no config to load
      return;
    }

    this.subscription = this.configService.getOrganizationConfig().subscribe({
      next: (result: ConfigDTO) => {
        this.isConfigLoaded = result !== null;
        this.changeDetector.markForCheck();
      },
    });
  }

  retry(): void {
    if (this.configService.requiresSessionReload) window.location.reload();
    else this.configService.getOrganizationConfig();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
